import React, { FC } from 'react';
import {
  telegramBotLink
  // viberBotLink
} from 'src/utils/links';
import NextImage from 'src/shared-components/NextImage/NextImage';
import useGTAG, { GTAGPrefix } from 'src/hooks/useGTAG';

const telegramIcon = 'shared/telegram-icon-grey.svg';

const socialMediaBots = [
  {
    icon: {
      link: telegramIcon,
      alt: 'telegram-icon',
      width: 28,
      height: 23
    },
    link: telegramBotLink
  }
  // TODO Activate the link when there is a correct viber link
  // {
  //   icon: {
  //     link: viberIcon,
  //     alt: 'viber-icon',
  //     width: 40,
  //     height: 44
  //   },
  //   link: viberBotLink
  // }
];

interface Props {
  gtagPrefix?: GTAGPrefix;
}

const SocialMediaBots: FC<Props> = ({ gtagPrefix }) => {
  const { trackGtagEvent } = useGTAG();
  return (
    <div className="flex flex-row items-center space-x-9 pl-2">
      {socialMediaBots.map(({ icon, link }, index) => (
        <a
          key={index + link}
          href={link}
          onClick={() => {
            trackGtagEvent(`${gtagPrefix}_support_telegram`);
          }}
        >
          <NextImage
            alt={icon.alt}
            src={icon.link}
            layout="fixed"
            quality={100}
            width={icon.width}
            height={icon.height}
          />
        </a>
      ))}
    </div>
  );
};

export default SocialMediaBots;
